import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { NotFoundComponent } from '@crowdctrl/shared';
import { authGuard } from './guards/auth.guard';
import { boardLockGuard } from './guards/board-lock.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'about/technical',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutTechnicalComponent),
  },
  {
    path: 'about/features',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutFeaturesComponent),
  },
  {
    path: 'about/how-it-works/manager',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutHowItWorksManagerComponent),
  },
  {
    path: 'about/how-it-works/service',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutHowItWorksServiceComponent),
  },
  {
    path: 'about/how-it-works/forms',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutHowItWorksFormsComponent),
  },
  {
    path: 'about/how-it-works/boards',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutHowItWorksBoardsComponent),
  },
  {
    path: 'about/how-it-works',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutHowItWorksComponent),
  },
  {
    path: 'about/future-directions',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutFutureDirectionsComponent),
  },
  {
    path: 'register-interest',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.RegisterInterestShellComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('@crowdctrl/shared').then((m) => m.RegisterInterestComponent),
      },
      {
        path: 'thanks',
        loadComponent: () =>
          import('@crowdctrl/shared').then((m) => m.RegisterInterestThanksComponent),
      },
    ],
  },
  {
    path: 'contact',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.ContactShellComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('@crowdctrl/shared').then((m) => m.ContactComponent),
      },
      {
        path: 'sent',
        loadComponent: () => import('@crowdctrl/shared').then((m) => m.ContactSentComponent),
      },
    ],
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.TermsComponent),
  },
  {
    path: 'about',
    loadComponent: () => import('@crowdctrl/shared').then((m) => m.AboutProjectComponent),
  },
  {
    path: 'boards/:workspaceId/:sessionId/:boardId',
    loadComponent: () =>
      import('./pages/boards/board-page/board-page.component').then((m) => m.BoardPageComponent),
    canActivate: [authGuard],
  },
  {
    path: 'boards/:workspaceId/:sessionId/:boardId/settings',
    loadComponent: () =>
      import('./pages/boards/board-settings/board-settings.component').then(
        (m) => m.BoardSettingsComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'boards/:workspaceId/:sessionId/:boardId/calling-settings',
    loadComponent: () =>
      import('./pages/boards/calling-settings/calling-settings.component').then(
        (m) => m.CallingSettingsComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'boards/:workspaceId/:sessionId/:boardId/waiting-settings',
    loadComponent: () =>
      import('./pages/boards/waiting-settings/waiting-settings.component').then(
        (m) => m.WaitingSettingsComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard, boardLockGuard],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
    canActivate: [authGuard, boardLockGuard],
  },
  {
    path: 'settings/developer',
    loadComponent: () =>
      import('./pages/settings/developer-settings/developer-settings.component').then(
        (m) => m.DeveloperSettingsComponent,
      ),
    canActivate: [authGuard, boardLockGuard],
  },
  {
    path: 'workspaces/select',
    loadComponent: () =>
      import('./pages/workspaces/select-workspace/select-workspace.component').then(
        (m) => m.SelectWorkspaceComponent,
      ),
    canActivate: [authGuard, boardLockGuard],
  },
  {
    path: 'workspaces/:workspaceId/sessions',
    loadComponent: () =>
      import('./pages/workspaces/workspace-sessions/workspace-sessions.component').then(
        (m) => m.WorkspaceSessionsComponent,
      ),
    canActivate: [authGuard, boardLockGuard],
  },
  {
    path: 'workspaces/:workspaceId/sessions/:sessionId/boards',
    loadComponent: () =>
      import('./pages/workspaces/workspace-boards/workspace-boards.component').then(
        (m) => m.WorkspaceBoardsComponent,
      ),
    canActivate: [authGuard, boardLockGuard],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
